export default "__VITE_ASSET__ChgVS1p$__"